// extracted by mini-css-extract-plugin
export default {"box":"PageBox_box__ZBji+","back":"PageBox_back__TQz2I","left":"PageBox_left__HzM2S"};